import API from "../../models/API";
import { CheckoutRecord } from "../../types/locks/CheckoutRecord";
import { LockData } from "../../types/locks/LockData";

export { getLockedModels, getModelLockInformation, unlockModel, lockModel };

/**
 * Get locked Models for a BC ID.
 * @param batchClassId
 * @returns undefined if request failed, otherwise `{ modelUuid: lockedUser }`
 */
async function getLockedModels(batchClassId: string) {
  // get list of updated lock info,
  return await API.get("/v0/lock/model", { batchClassId })
    .then((res) => {
      if (!res.ok) {
        throw new Error("API did not respond correctly.");
      }
      return res.json() as Promise<CheckoutRecord[]>;
    })
    .catch((err) => {
      console.error("Could not get lock info for batches", err);
      return undefined;
    });
}

/**
 * Get CheckoutRecord for a Model
 * @param batchClassId
 * @param modelName
 * @returns true if the Model could be locked
 */
async function getModelLockInformation(
  modelUuid: string | undefined,
  batchClassId: string,
): Promise<CheckoutRecord | undefined> {
  console.debug(`getModelLockInformation(${modelUuid}, ${batchClassId})`);
  // get list of updated lock info,
  const didModelLock = await API.get(`/v0/lock/model/${modelUuid ?? ""}`, {
    batchClassId,
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error("API did not respond correctly.");
      }
      return res.json();
    })
    .then((res) => res as CheckoutRecord)
    .catch((err) => {
      console.error(
        `Could not retrieve lock information for [${modelUuid}:${batchClassId}].`,
        err,
      );
      return undefined;
    });
  return didModelLock;
}

/**
 * Ask API to unlock Model.
 * @param modelUuid
 * @param batchClassId
 * @returns true if the Model could be unlocked
 */
function unlockModel(
  modelUuid: string,
  batchClassId: string,
): Promise<boolean> {
  return API.delete(`/v0/lock/model/${modelUuid}`, { batchClassId })
    .then((res) => {
      return res.ok;
    })
    .catch((err) => {
      console.error(
        `API did not respond correctly when unlocking Model [${modelUuid}:${batchClassId}]`,
        err,
      );
      return false;
    });
}

/**
 * Lock Model
 * @param batchClassId
 * @param modelName
 * @returns true if the Model could be locked
 */
function lockModel(modelUuid: string, batchClassId: string): Promise<boolean> {
  return API.post(`/v0/lock/model/${modelUuid}`, { batchClassId })
    .then((res) => {
      return res.ok;
    })
    .catch((err) => {
      console.error(
        `API did not respond correctly when locking Model [${modelUuid}:${batchClassId}]`,
        err,
      );
      return false;
    });
}
